import React from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, startOfWeek, getDay } from 'date-fns';
import { de, fr, es, enUS } from 'date-fns/locale';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const locales = { en: enUS, es, de, fr };

const localizer = dateFnsLocalizer({ format, startOfWeek, getDay, locales });

const CalendarTab = ({
  events,
  eventsLoaded,
  calendarHeight,
  currentView,
  onViewChange,
  onRangeChange,
  onOpenModal,
  eventStyleGetter,
  currentLang,
  t,
}) => (
  <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden rbc-styled">
    <div className="p-3 md:p-5 overflow-x-auto">
      {!eventsLoaded ? (
        <div className="space-y-2 py-4">
          <div className="animate-pulse bg-gray-100 rounded-xl h-12 w-full" />
          <div className="animate-pulse bg-gray-100 rounded-xl h-12 w-3/4" />
          <div className="animate-pulse bg-gray-100 rounded-xl h-12 w-5/6" />
        </div>
      ) : (
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          eventPropGetter={eventStyleGetter}
          style={{ height: calendarHeight }}
          onSelectEvent={onOpenModal}
          view={currentView}
          onView={onViewChange}
          onRangeChange={(range) => {
            if (Array.isArray(range)) {
              onRangeChange({ start: range[0], end: range[range.length - 1] });
            } else if (range.start && range.end) {
              onRangeChange({ start: range.start, end: range.end });
            }
          }}
          popup
          views={['month', 'agenda', 'day']}
          culture={currentLang}
          messages={{
            next: t('calendar.next'), previous: t('calendar.previous'), today: t('calendar.today'),
            month: t('calendar.month'), week: t('calendar.week'), day: t('calendar.day'),
            agenda: t('calendar.agenda'), noEventsInRange: t('calendar.noEvents'),
          }}
          components={{
            agenda: {
              event: ({ event }) => (
                <span className="font-semibold text-sm text-gray-900">{event.title}</span>
              ),
            },
          }}
        />
      )}
    </div>
  </div>
);

export default CalendarTab;
